import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'

interface Props {
  children: ReactNode
  /** Layout for the card's own content (flex direction, gap, padding override). */
  className?: any
  dataTestId?: string
}

/**
 * The white bordered block every admin page section sits in — `SectionCard`'s box without its
 * title row. Use it for page headers and forms so they line up with the cards around them.
 */
const ContentCardComponent = ({ children, className, dataTestId }: Props) => {
  return (
    <section
      css={[
        tw`shrink-0 rounded-lg border border-solid border-shades-100 bg-shades-0 p-6`,
        className,
      ]}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      {children}
    </section>
  )
}

export const ContentCard = memo(ContentCardComponent)
